import { useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { apiFetch } from '../lib/api'

export default function ResetPassword() {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const token = searchParams.get('token') || ''

  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [success, setSuccess] = useState('')

  async function handleSubmit(e) {
    e.preventDefault()
    setError('')
    setSuccess('')

    if (!token) {
      setError('Missing reset token. Please use the latest link from your email.')
      return
    }
    if (password.length < 8) {
      setError('Password must be at least 8 characters.')
      return
    }
    if (password !== confirmPassword) {
      setError('Passwords do not match.')
      return
    }

    setLoading(true)
    try {
      const res = await apiFetch('/auth/reset-password', {
        method: 'POST',
        body: JSON.stringify({ token, password }),
      })
      const data = await res.json()
      if (!res.ok) {
        setError(data.message || 'Failed to reset password.')
        return
      }
      setSuccess(data.message || 'Password reset successful. You can now log in.')
    } catch {
      setError('Network error.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="min-h-screen bg-gradient-to-b from-orange-50 to-white px-4 py-12">
      <div className="mx-auto w-full max-w-md rounded-3xl border border-orange-100 bg-white p-8 shadow-xl">
        <p className="title-font text-xs font-bold uppercase tracking-[0.2em] text-orange-600">Co-Eater</p>
        <h1 className="title-font mt-2 text-2xl font-bold text-gray-900">Reset your password</h1>
        <p className="mt-2 text-sm text-gray-600">Enter your new password below.</p>

        <form className="mt-6 space-y-4" onSubmit={handleSubmit}>
          <input
            type="password"
            placeholder="New password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            className="w-full rounded-xl border border-orange-200 bg-white px-4 py-3 text-sm text-gray-900 outline-none focus:border-orange-500"
            autoComplete="new-password"
          />
          <input
            type="password"
            placeholder="Confirm new password"
            value={confirmPassword}
            onChange={e => setConfirmPassword(e.target.value)}
            className="w-full rounded-xl border border-orange-200 bg-white px-4 py-3 text-sm text-gray-900 outline-none focus:border-orange-500"
            autoComplete="new-password"
          />

          {error && <p className="rounded-xl border border-red-200 bg-red-50 px-3 py-2 text-xs text-red-700">{error}</p>}
          {success && <p className="rounded-xl border border-green-200 bg-green-50 px-3 py-2 text-xs text-green-700">{success}</p>}

          <button
            type="submit"
            disabled={loading}
            className="w-full rounded-full bg-gradient-to-r from-red-500 to-orange-500 py-3 text-sm font-bold text-white hover:from-red-600 hover:to-orange-600 disabled:opacity-50"
          >
            {loading ? 'Resetting password...' : 'Reset Password'}
          </button>

          <button
            type="button"
            onClick={() => navigate('/')}
            className="w-full text-center text-xs font-semibold text-orange-600 hover:underline"
          >
            Back to login
          </button>
        </form>
      </div>
    </div>
  )
}
